import React from "react";
export function MetricCard({ label, value, hint, className = "", }: {
    label?: React.ReactNode;
    value?: React.ReactNode;
    hint?: React.ReactNode;
    className?: string;
}): any {
    return (<div className={`rounded-input border border-border bg-surface-elevated px-3 py-2 ${className}`}>
      <p className="text-[11px] uppercase tracking-wide text-fg-subtle">{label}</p>
      <p className="text-base font-semibold text-fg">{value}</p>
      {hint ? <p className="text-xs text-fg-subtle">{hint}</p> : null}
    </div>);
}
type MetricStripItem = {
    key?: string;
    label?: React.ReactNode;
    value?: React.ReactNode;
    hint?: React.ReactNode;
};
export function MetricStrip({ items, className = "" }: {
    items?: MetricStripItem[];
    className?: string;
}): any {
    const list = items ?? [];
    return (<div className={`grid grid-cols-2 gap-2 md:grid-cols-5 ${className}`}>
      {list.map((item: any, idx: any): any => (<MetricCard key={item.key ?? `metric-${idx}`} label={item.label} value={item.value} hint={item.hint}/>))}
    </div>);
}
